export const selectCards = (state) => state.entities.cards;
export const selectCard = (state, cardId) => selectCards(state)[cardId];
